import React from 'react';
import { Box } from '@chakra-ui/react';

export interface CheckboxCardProps {
  isSelected: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export const CheckboxCard: React.FC<CheckboxCardProps> = ({ isSelected, onClick, children }) => (
  <Box
    as="button"
    w="full"
    textAlign="left"
    borderWidth={1}
    borderRadius="sm"
    px={2.5}
    py={2}
    display="flex"
    alignItems="center"
    justifyContent="flex-start"
    borderColor={isSelected ? 'river.solid' : 'gray.muted'}
    bg="bg"
    cursor="pointer"
    onClick={onClick}
    _hover={{
      bg: 'rgba(0, 0, 0, 0.02)',
    }}
  >
    {children}
  </Box>
);


